var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4958_55011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7539 8.63623L19.7956 17.5112C19.7956 18.0112 19.622 18.4348 19.2747 18.7821C18.9275 19.1293 18.5039 19.3029 18.0039 19.3029H3.79557C3.29557 19.3029 2.87196 19.1293 2.52474 18.7821C2.17752 18.4348 2.00391 18.0112 2.00391 17.5112V8.63623C2.00391 7.96956 2.28168 7.45567 2.83724 7.09456L10.8789 2.38623L18.9206 7.09456C19.4761 7.45567 19.7539 7.96956 19.7539 8.63623ZM10.8789 13.0529L18.2539 8.46956L10.8789 4.1779L3.54557 8.46956L10.8789 13.0529Z",
    fill: "#130F26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4958_55011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(2.00391 2.17798)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.67bb912a6fbe270942cbdad083a90cea.svg";
export { ForwardRef as ReactComponent };